import React, { useMemo } from "react";
import { Icon } from "@coverme/icons";
import moment from "moment";
import { Link } from "react-router-dom";
import "./Retrocheck.scss";
import { isNotNullOrWhitespace, getFormattedAddress } from "../../services/stringService";
import { Tooltip } from "../Tooltips/Tooltip";
import { TooltipMessage, TooltipTrigger } from "@coverme/elements";

function getDateFormat(date) {
    const isMoreThan1Day = moment().diff(moment(date), "days") >= 1;
    const value = isMoreThan1Day ? moment(date).format("MM.DD.YYYY hh:mm A") : moment(date).fromNow();
    return value;
}

export const RetrocheckFacesheetTop = ({ patient }) => {
    return (
        <div className="facesheet-top">
            {patient && (
                <h2 className="facesheet-top__name">
                    {patient?.firstName} {patient?.middleInitial} {patient?.lastName} {patient?.suffix}
                </h2>
            )}
            {patient && (
                <div className="facesheet-top__content">
                    <div className="facesheet-top__left">
                        <div className="facesheet-top__info">
                            <div className="facesheet-top__info-item">
                                <span className="h5">DOB </span>
                                <span className="p-regular">{moment(patient?.dateOfBirth).format("MM.DD.YYYY")}</span>
                            </div>
                            <div className="facesheet-top__info-item">
                                <span className="h5">ADDRESS </span>
                                <span className="p-regular">{getFormattedAddress(patient.address)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="facesheet-top__right">
                        <div className="facesheet-top__info-item">
                            <span className="h5">MRN </span>
                            <span className="p-regular">{patient.mrn}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
